import React from 'react';
import classnames from 'classnames';
import MaterialTooltip from '@material-ui/core/Tooltip';
import styles from './Tooltip.scss';

const Tooltip = ({ className, ...props }) =>
    <MaterialTooltip
        className={classnames(styles.baseTooltip, className)}
        {...props}
    />;

export default Tooltip;

